import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { Edit3, Eye, Trash2, User } from 'react-feather';
import IconButton from '@mui/material/IconButton';
import '../../styles/table.css'; // Importing the external CSS
import Grid from '@mui/material/Grid2';
import { PlusCircle } from 'react-feather';
import { Chip, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Toastmessage from '../../components/Toast';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { authApi } from '../../api/api';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { logout } from '../../features/auth/AuthSlice';


export default function LocationTable({ apiResponse }) {
  const [rows, setRows] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [open, setOpen] = useState(false);
  const [deleteUser, setDeleteUser] = useState('')
  const [filteredRows, setFilteredRows] = useState([]); // Store filtered data

  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  const dispatch = useDispatch()
  const navigate = useNavigate();

  useEffect(() => {
    if (apiResponse?.data?.actions?.list) {
      fetchUsers()
    }
  }, [])

  const getModuleColor = (module) => {
    switch (module) {
      case 'FT':
        return '#00AC69';
      case 'T&B':
        return '#0061F2';
      case 'PM':
        return '#6900C7';
      default:
        return '#333';
    }
  };

  const columns = [
    {
      field: 'full_name',
      headerName: 'Staff Name',
      flex: 1,
      renderCell: (params) => (
        <a href="#" className="location-link">
          {params.value}
        </a>
      ),
    },
    { field: 'email', headerName: 'Email ID', flex: 1 },
    { field: 'designation_name', headerName: 'Professional Type', flex: 1 },
    { field: 'role_name', headerName: 'User Role', flex: 0.5 },

    { field: 'bonus', headerName: 'Bonus Per Month ($)', flex: 1 },
    { field: 'extra_bonus', headerName: 'Ex.Bonus %', flex: 0.8 },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            {params.row.status == 1 ? 'Active' : 'Inctive'}
          </div>
        )
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.8,
      renderCell: (params) => (
        <>
          {apiResponse?.data?.actions?.view && (
            <IconButton
              onClick={() => handleClickView(`${params.row.id}`)}
              sx={{
                backgroundColor: 'var(--action-icon-bg)',
                color: 'var(--action-icon-color)',
                borderRadius: '50%',
                padding: '8px', // Reduce padding size
                marginRight: '8px',
              }}
              size="small" // Decrease the button size
            >
              <Eye size={16} /> {/* Smaller Feather icon size */}
            </IconButton>
          )}
          {apiResponse?.data?.actions?.edit && (
            <IconButton
              onClick={() => handleClickEdit(`${params.row.id}`)}
              sx={{
                backgroundColor: 'var(--action-icon-bg)',
                color: 'var(--action-icon-color)',
                borderRadius: '50%',
                padding: '8px', // Reduce padding size
                marginRight: '8px',
              }}
              size="small" // Decrease the button size
            >
              <Edit3 size={16} /> {/* Smaller Feather icon size */}
            </IconButton>
          )}
          {apiResponse?.data?.actions?.delete && (
            <IconButton
              onClick={() => handleClickOpen(params.row.id)}
              sx={{
                backgroundColor: 'var(--action-icon-bg)',
                color: 'var(--action-icon-color)',
                borderRadius: '50%',
                padding: '8px', // Reduce padding size
              }}
              size="small" // Decrease the button size
            >
              <Trash2 size={16} /> {/* Smaller Feather icon size */}
            </IconButton>
          )}
        </>
      ),
    },
  ];




  const fetchUsers = async () => {
    const input_token = 'ALL_EMPLOYEES'; // Replace with your actual token
    const apiUrl = 'list_of_all_employee'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        setRows(data.clients);
        setFilteredRows(data.clients);
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };

  const handleDelete = () => {
    // Define the function for the API call
    const fetchData = async () => {
      const input_token = deleteUser + 'DELETE_FIRM_EMP';; // Replace with your actual token
      const apiUrl = 'delete_firm_employee'; // Replace with the actual API endpoint

      const dataInput = {
        id: deleteUser,
        login_user_id: userID
      };
      try {
        const data = await authApi(input_token, dataInput, apiUrl, token);

        if (data && data.success) {
          await Toastmessage(data.message, true);
          setOpen(false);
          await fetchUsers(); // Refresh the list after deletion
        } else if (data && data.message === 'Token has expired') {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else if (data === undefined) {
          await Toastmessage('No response from server', false);
        } else {
          await Toastmessage(data?.message || 'An error occurred', false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else {
          await Toastmessage('Something went wrong', false);
        }
      }

    };

    // Call the function to make the API call
    fetchData();

  };

  const handleClickOpen = (id) => {
    setOpen(true);
    setDeleteUser(id)
  };

  const handleClickView = (id) => {
    navigate('/viewuser', { state: { userId: id } });
  };

  const handleClickEdit = (id) => {
    navigate('/edituser', { state: { userId: id } });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);

    // Search all fields in rows
    const filteredData = rows.filter((row) =>
      Object.values(row).some((field) =>
        String(field).toLowerCase().includes(value)
      )
    );
    setFilteredRows(filteredData); // Update filtered rows
  };

  const clearSearch = () => {
    setSearchText('');
    setFilteredRows(rows); // Reset to original data
  }

  return (

    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom='20px'
        backgroundColor='var(--theme-bg-light)'
        padding={2}
        borderRadius={1}
        className="title_head"
      >
        {/* Left Section */}
        <Box display="flex" alignItems="center">
          <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
          <Typography fontSize={12} color="var(--text-color)">
            User List
          </Typography>
        </Box>

        {/* Right Section */}
        <Button
          variant="outlined"
          component={Link}
          to="/adduser"
          sx={{
            backgroundColor: 'var(--back-button)',
            color: "var(--back-color)",
            fontWeight: 'bold',
            border: 'none',
            padding: '10px 20px'
          }}
          startIcon={<PlusCircle sx={{ fontSize: 17 }} />}
          style={{ textTransform: 'none' }}
        >
          Add New User
        </Button>
      </Box>


      <Box className="location-container" m={3}>

        <Box className="location-header ">

          <h2>Total Users {rows ? rows.length : 0}</h2>
          <Box sx={{ position: 'relative', width: '300px' }}> {/* Adjust width as needed */}
            <TextField
              label="Search"
              variant="outlined"
              value={searchText}
              onChange={handleSearch}
              className="search-input"
              fullWidth
              InputProps={{
                endAdornment: searchText && (
                  <span
                    onClick={() => clearSearch()}
                    style={{
                      cursor: 'pointer',
                      color: '#aaa',
                      marginRight: '10px',
                    }}
                  >
                    ✕
                  </span>
                ),
              }}
            />
          </Box>
        </Box>
        <div sx={{ m: 0, p: 0 }}>
          <Box sx={{ width: '100%', display: 'flex' }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pageSize={5}
              autoHeight
              pagination
              disableSelectionOnClick
              rowsPerPageOptions={[]}
              className="data-grid"
              sx={{ width: '100%' }} // Ensure DataGrid takes full width
            />
          </Box>
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Deletion?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this User?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Disagree</Button>
            <Button onClick={handleDelete} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}
